import { render, staticRenderFns } from "./configure.vue?vue&type=template&id=5f468c76&"
import script from "./configure.vue?vue&type=script&lang=js&"
export * from "./configure.vue?vue&type=script&lang=js&"
import style0 from "./configure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports